export enum PinType {
  HAZARD = 'hazard',
  SPEED_TRAP = 'speed_trap',
  POTHOLE = 'pothole',
  ROADWORK = 'roadwork',
  ACCIDENT = 'accident',
  TRAFFIC_CAMERA = 'traffic_camera',
  PARTY = 'party',
  BUSINESS = 'business'
}

export interface IPinType {
  type: PinType;
  displayName: string;
  emoji: string;
  color: string;
}

export const PIN_TYPES: Record<PinType, IPinType> = {
  [PinType.HAZARD]: {
    type: PinType.HAZARD,
    displayName: 'Hazard',
    emoji: '⚠️',
    color: '#ff9500'
  },
  [PinType.SPEED_TRAP]: {
    type: PinType.SPEED_TRAP,
    displayName: 'Speed Trap',
    emoji: '👮',
    color: '#ff3b30'
  },
  [PinType.POTHOLE]: {
    type: PinType.POTHOLE,
    displayName: 'Pothole',
    emoji: '🕳️',
    color: '#8b4513'
  },
  [PinType.ROADWORK]: {
    type: PinType.ROADWORK,
    displayName: 'Road Work',
    emoji: '🚧',
    color: '#ffcc00'
  },
  [PinType.ACCIDENT]: {
    type: PinType.ACCIDENT,
    displayName: 'Accident',
    emoji: '🚗💥',
    color: '#ff3b30'
  },
  [PinType.TRAFFIC_CAMERA]: {
    type: PinType.TRAFFIC_CAMERA,
    displayName: 'Traffic Camera',
    emoji: '📹',
    color: '#9c27b0'
  },
  [PinType.PARTY]: {
    type: PinType.PARTY,
    displayName: 'Party',
    emoji: '🎉',
    color: '#9c27b0'
  },
  [PinType.BUSINESS]: {
    type: PinType.BUSINESS,
    displayName: 'Business',
    emoji: '🎁',
    color: '#007aff'
  }
};
